import Container from "@client/content/Containers/container";
import { CountdownDiv } from "@client/content/hocs/countdown";
import { getContainerProps } from "@client/content/lib/helper";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { type CountdownOptions } from "@client/lib/jquery/countdown";
import { type WithIsEditMode } from "@client/types";
import * as React from "react";
import { fetchFunnelInfo, type FunnelInfo } from "./lib";
import "./style.less";

export type TimerProps = RootContainerProps &
  WithIsEditMode & {
    apiInfo: ModuleApiInfo;
    className: string;
    countdownOptions: CountdownOptions;

    isInheritFunnel: boolean;
  };

interface State {
  countdownOptions: CountdownOptions | null;
  isLoading: boolean;
  funnelInfo: FunnelInfo | null;
}
export default class CountdownTimers extends React.PureComponent<TimerProps, State> {
  public state: State = {
    countdownOptions: null,
    isLoading: false,
    funnelInfo: null
  };

  public componentWillMount(): void {
    this._init(this.props);
  }

  public UNSAFE_componentWillReceiveProps(nextProps: Readonly<TimerProps>) {
    this._init(nextProps);
  }

  public render() {
    const { props, state } = this;

    return (
      <Container className="cartly_countdown_timers" {...getContainerProps(props)}>
        {state.isLoading && <div className="cartly_countdown_timers wsc_loading transparent" />}
        {!state.isLoading && <CountdownDiv className={props.className} countdownOptions={state.countdownOptions!} />}
      </Container>
    );
  }

  private _init = (props: TimerProps) => {
    if (this.state.isLoading) return;

    if (props.isInheritFunnel && !this.state.funnelInfo) {
      this.setState({ isLoading: true });
      fetchFunnelInfo(props.apiInfo).then((data: FunnelInfo | null) => {
        this._setCountdownOptions(props, data);
        this.setState({ isLoading: false, funnelInfo: data });
      });
    } else {
      this._setCountdownOptions(props, this.state.funnelInfo);
    }
  };

  private _setCountdownOptions = (props: TimerProps, funnelInfo: FunnelInfo | null) => {
    let countdownOptions = {
      ...props.countdownOptions
    };

    if (props.isInheritFunnel && funnelInfo) {
      Object.assign(countdownOptions, {
        date: funnelInfo.expiryDate ? new Date(funnelInfo.expiryDate) : undefined,
        redirectUrl: props.isEditMode ? undefined : funnelInfo.redirectUrl
      });
    }

    this.setState({ countdownOptions });
  };
}
